var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.781 20.313a8.531 8.531 0 1 0 0-17.063 8.531 8.531 0 0 0 0 17.063ZM17.814 17.814l4.936 4.936","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

SearchInline.defaultProps = {"width":"26","height":"26","fill":"none","viewBox":"0 0 26 26"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
